import React, { useState } from "react";
import { withStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import AddButton from "components/CustomButtons/AddButton";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: '16px',
  },
  closeButton: {
    position: "absolute",
    right: '8px',
    top: '8px',
    color: '#9e9e9e',
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

export default function CustomDialog(props) {
  const {
    id,
    icon,
    buttonName,
    dialogTitle,
    dialogContent,
    open,
    handleClickOpen,
    handleClose,
    maxWidth,
    disabled,
  } = props;

  return (
    <>
      {(icon || buttonName) && (
        <AddButton handleSubmit={handleClickOpen} disabled={disabled}>
          {icon}
          {buttonName}
        </AddButton>
      )}
      <Dialog
        onClose={handleClose}
        aria-labelledby={`${id}-dialog-title`}
        fullWidth={true}
        maxWidth={maxWidth || "md"}
        open={open}
      >
        <DialogTitle id={`${id}-dialog-title`} onClose={handleClose}>
          {dialogTitle}
        </DialogTitle>
        <DialogContent dividers>{dialogContent}</DialogContent>
      </Dialog>
    </>
  );
}
